<template>
    <div>
        <el-image :src="payUrl"
            :preview-src-list="[payUrl]">
        </el-image>
    </div>
</template>
<script>
export default {
    data() {
        return {
            payUrl:"",
        }
    },
    created() {
        let userId = this.getUrlKey("userId");
        let code = this.getUrlKey("code");
        if (userId || code) {
            if (userId) {
                this.getCorpUserInfo(userId);
            }
        } else {
            window.location.href = "http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechatback/getThirdCorpidCodeNew?state=" + encodeURIComponent("http://staff.shmiaojie.cn/#/payimage");
        }
    },
    methods:{
        getAllStoreById(storeid){
            this.$post("store/getAllStoreById",{storeid:storeid}).then(res=>{
                if(res.sucess){
                    this.payUrl=this.baseImageUrl+res.object.branlogo;
                }
                else{
                    this.$message({message: res.message, type: 'error'});
                }
            });
        },
        getCorpUserInfo(staffid) {
            this.$post("wechat/getCorpUserInfo", {staffid: staffid}).then(res => {
                if (res.sucess) {
                    let data = res.object;
                    if (data.staff == null || data.staff == undefined) {
                        this.$message.error('没有找到您的信息');
                    } else {
                        this.staff = data.staff;
                        this.staffid=data.staff.staffid;
                        localStorage.setItem("token", data.token);
                        localStorage.setItem("staffid", data.staff.staffid);
                        localStorage.setItem("deptid", data.staff.deptid);
                        localStorage.setItem("staffname", data.staff.staffname);
                        localStorage.setItem("posid", data.staff.posid);
                        localStorage.setItem("storename", data.staff.storename);
                        localStorage.setItem("storeid", data.staff.storeid);
                        localStorage.setItem("parentstoreid", data.staff.storeid);
                        this.getAllStoreById(data.staff.storeid);
                    }
                } else {
                    window.close();
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/page/pay/payimage.vue